import React, { useState } from "react";
import {
  FaSearch,
  FaCheckCircle,
  FaTimes,
} from "react-icons/fa";

import "./AllDepositCountry.css";

export default function CountrySelector({
  selected,
  onSelect,
  onClose,
}) {
  const [search, setSearch] = useState("");

  const countries = [
    {
      name: "Kenya",
      flag: "🇰🇪",
      currency: "KES",
      rate: 129.50,
    },
    {
      name: "Uganda",
      flag: "🇺🇬",
      currency: "UGX",
      rate: 3725,
    },
    {
      name: "Rwanda",
      flag: "🇷🇼",
      currency: "RWF",
      rate: 1415,
    },
    {
      name: "Burundi",
      flag: "🇧🇮",
      currency: "BIF",
      rate: 2920,
    },
    {
      name: "DR Congo",
      flag: "🇨🇩",
      currency: "CDF",
      rate: 2895,
    },
    {
      name: "Zambia",
      flag: "🇿🇲",
      currency: "ZMW",
      rate: 25.70,
    },
    {
      name: "Botswana",
      flag: "🇧🇼",
      currency: "BWP",
      rate: 13.70,
    },
    {
      name: "Madagascar",
      flag: "🇲🇬",
      currency: "MGA",
      rate: 4550,
    },
    {
      name: "Malawi",
      flag: "🇲🇼",
      currency: "MWK",
      rate: 1745,
    },
    {
      name: "Mozambique",
      flag: "🇲🇿",
      currency: "MZN",
      rate: 64,
    },
    {
      name: "South Sudan",
      flag: "🇸🇸",
      currency: "SSP",
      rate: 5200,
    },
    {
      name: "Zimbabwe",
      flag: "🇿🇼",
      currency: "USD",
      rate: 1,
    },
  ];

  const filtered = countries.filter(
    (country) =>
      country.name
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      country.currency
        .toLowerCase()
        .includes(search.toLowerCase())
  );

  const handleSelect = (country) => {
    // Tuma country kwa DepositExpress
    onSelect(country);

    // Funga popup
    onClose();
  };

  return (
    <div className="country-overlay">

      <div className="country-modal">

        {/* Drag bar */}
        <div className="modal-bar"></div>

        {/* Header */}
        <div className="modal-header">

          <h2>Select Country</h2>

          <FaTimes
            className="close-btn"
            onClick={onClose}
          />

        </div>

        {/* Search */}
        <div className="search-box">

          <FaSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search country..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

        </div>

        {/* Country List */}
        <div className="country-list">

          {filtered.map((item) => (

            <div
              key={item.currency}
              className="country-item"
              onClick={() =>
                handleSelect(item)
              }
            >

              <div className="country-left">

                <span className="flag">
                  {item.flag}
                </span>

                <div>

                  <div className="country-name">
                    {item.name}
                  </div>

                  <div className="country-code">
                    {item.currency}
                  </div>

                </div>

              </div>

              {selected?.currency === item.currency && (
                <FaCheckCircle className="check" />
              )}

            </div>

          ))}

        </div>

      </div>

    </div>
  );
}